import { DefaultService, Order } from "@/api/SolarCloudApi";
import { MutationConfig } from "@/lib/react-query";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import getNewOrderOptions from "./useNewOrder";

async function updateNewOrder(data: Order) {
  // Update Order does not allow payments to be set
  if (data.payments?.length) {
    delete data.payments;
  }
  // remove Order Item UUIDs
  data.items = data.items?.map((item) => {
    delete item.uuid;
    return item;
  });

  const response = await DefaultService.newOrderUpsert(data.uuid!, data) as Order;
  return response;
}

type UseUpdateNewOrderOptions = {
  mutationConfig?: MutationConfig<typeof updateNewOrder>;
  refetchQueries?: boolean;
};
export function useUpdateNewOrder({
  mutationConfig,
  refetchQueries = true,
}: UseUpdateNewOrderOptions = {}) {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    ...restConfig,
    mutationFn: updateNewOrder,
    onSuccess: (data, ...args) => {
      queryClient.setQueryData<Order>(
        getNewOrderOptions(data.uuid!).queryKey,
        data
      );
      if (refetchQueries) {
        queryClient.refetchQueries({
          queryKey: getNewOrderOptions(data.uuid!).queryKey,
        });
      }
      onSuccess?.(data, ...args);
    },
    onMutate: async (newOrder) => {
      await queryClient.cancelQueries({
        queryKey: getNewOrderOptions(newOrder.uuid!).queryKey.slice(0, -1),
      });

      const previousOrder = queryClient.getQueryData<Order>(
        getNewOrderOptions(newOrder.uuid!).queryKey
      );

      queryClient.setQueryData<Order>(
        getNewOrderOptions(newOrder.uuid!).queryKey,
        newOrder
      );
      return;
      // return { previousOrder };
    },
    onError: (error) => {
      console.error("Error updating new order:", error);
    },
  });
}
